import { lazy } from 'react'

export const PermissionDeniedPage = lazy(() => import('./PermissionDeniedPage'))
